import LocalizedStrings from "react-localization";

export const creativeAnalysisStrings = new LocalizedStrings({
  en: {
    title: "Creative Analysis",
    exportButton: "Export",
    resetFiltersButton: "Reset",
    filterColumns: "Filter columns",
    update: "Update",
    resetColumns: "Reset columns",
    creativeId: "Creative ID",
    asin: "ASIN",
    product: "Product",
    productId: "Product ID",
    advertiser: "Advertiser",
    advertiserId: "Advertiser ID",
    advertiserName: "Ad Name",
    advertiserPaid: "Ad Paid",
    keyword: "Keyword",
    sponsorType: "Sponsor Type",
    creativesCount: "Number",
    status: "Status",
    listView: "List View",
    carouselView: "Carousel View",
    errors: {
      TotalResultsExceedsMaxAllowed:
        "There are too many results. Please refine your search.",
      NoResults: "No results found. Please refine your search.",
    },
  },
  fr: {
    title: "Analyse Visuel",
    exportButton: "Exporter",
    resetFiltersButton: "Réinitialiser",
    filterColumns: "Filtrer les colonnes",
    update: "Réactualiser",
    resetColumns: "Réinitialiser les colonnes",
    creativeId: "Creative ID",
    asin: "ASIN",
    product: "Produit",
    productId: "ID Produit",
    advertiser: "Annonceur",
    advertiserId: "ID annonceur",
    advertiserName: "Ad Name",
    advertiserPaid: "Ad Paid",
    keyword: "Keyword",
    sponsorType: "Type de sponsor",
    creativesCount: "Nombre",
    status: "Statut",
    listView: "Vue de Liste",
    carouselView: "Vue Carrousel",
    errors: {
      TotalResultsExceedsMaxAllowed:
        "Il y a trop de résultats. Veuillez affiner votre recherche.",
      NoResults: "Aucun résultat trouvé. Veuillez affiner votre recherche.",
    },
  },
});
